/**
 * Send a message to the parent app choosing the correct the mechanism
 * @param data
 */
export function sendMessageToApp(data: any): void {
  let w = window as any;
  if (w?.webkit?.messageHandlers?.observe?.postMessage) {
    w.webkit.messageHandlers.observe.postMessage(data);
  } else if (w?.appBotInterface?.postMessage) {
    w.appBotInterface.postMessage(JSON.stringify(data));
  }

  // always do this, for embedded iframe deployments (e.g. bot dashboard, e2e)
  window.parent?.postMessage(data, '*');
}
